export const iconFontAwesomeAnimalsShieldDog = (
	<i className="fa-solid fa-shield-dog"></i>
);
